import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type PaneListEmptyStateProps = {
  icon: ReactNode
  title: string
  description: string
  action?: ReactNode
  className?: string
}

/** Shared empty state for pane list sections (organisations, jobs, etc.). */
export function PaneListEmptyState({
  icon,
  title,
  description,
  action,
  className,
}: PaneListEmptyStateProps) {
  return (
    <div className={cn('py-12 text-center', className)}>
      <div className="mx-auto mb-4 flex justify-center text-muted-foreground [&_svg]:size-12">{icon}</div>
      <h3 className="mb-2 text-lg font-semibold">{title}</h3>
      <p className="mb-4 text-muted-foreground">{description}</p>
      {action}
    </div>
  )
}
